import territoriesJson from '@/assets/territories.json';
import { IOptions } from '@/data/models/option';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import _ from 'lodash';

export default function useGetTerritoriesQuery(): UseQueryResult<
  IOptions[],
  Error
> {
  return useQuery({
    queryKey: ['territories'],
    queryFn: async () => {
      return _.sortBy(territoriesJson, ['DisplayName']).map((t: any) => ({
        label: t.DisplayName,
        value: t.Reference,
      }));
    },
    staleTime: Infinity,
  });
}
